import i18n from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import axios from "axios"

const loadLocaleResources = async locale => {
  const resources = { translation: {} };
  const baseUrl = '/locale/';

  // Fetch default locale file (English as fallback)
  try {
    const defaultResponse = await axios.get(`${baseUrl}locale.json`);
    Object.assign(resources.translation, defaultResponse.data);
  } catch {
    console.log('Could not load default locale file');
  }

  // Fetch locale-specific file
  try {
    const localeResponse = await axios.get(
      `${baseUrl}locale_${locale}.json`
    );
    Object.assign(resources.translation, localeResponse.data);
  } catch {
    console.debug(`Could not load ${locale} translation file`);
  }

  return { [locale]: resources };
};

const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.languages?.[0] || 'en';
  const shortLang = browserLang.split('-')[0];
  return shortLang;
};

try {
  localStorage.removeItem('i18nextLng');
  document.cookie = 'i18next=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie =
    'i18nextLng=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
} catch (e) {
  console.log('Could not clear i18next cache:', e);
}

const initResources = async () => {
  try {
    const browserLang = getBrowserLanguage();
    const supportedLngs = [
      'en',
      'ko',
      'zh',
      'ja',
      'de',
      'fr',
      'es',
      'it',
      'pt',
      'ru',
      'tr',
      'pl',
      'cs',
      'sk',
      'th',
      'vi',
      'id',
      'in',
      'ar',
      'he',
      'iw',
      'el',
    ];
    const detectedLng = supportedLngs.includes(browserLang)
      ? browserLang
      : 'en';

    const resources = await loadLocaleResources(detectedLng);

    Object.keys(resources).forEach(locale => {
      i18n.addResourceBundle(
        locale,
        'translation',
        resources[locale].translation,
        true,
        true
      );
    });

    i18n.changeLanguage(detectedLng);
  } catch (error) {
    console.warn('Failed to load initial language resources:', error);
  }
};

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init(
    {
      fallbackLng: 'en',
      supportedLngs: [
        'en',
        'ko',
        'zh',
        'de',
        'fr',
        'es',
        'it',
        'pt',
        'ru',
        'tr',
        'pl',
        'cs',
        'sk',
        'th',
        'vi',
        'id',
        'in',
        'ar',
        'he',
        'iw',
        'el',
      ],
      ns: ['translation'],
      defaultNS: 'translation',
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false,
      },
      detection: {
        order: ['navigator', 'htmlTag'],
        caches: [],
        lookupCookie: false,
        cookieMinutes: 0,
      },
    },
    err => {
      if (err) {
        console.error('i18n initialization error:', err);
      }
      initResources();
    }
  );

export default i18n;